import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalSwipeDirective } from '../../../shared/directives/modal-swipe/modal-swipe.directive';
import {
  AsyncPipe,
  LowerCasePipe,
  NgClass,
  NgFor,
  NgIf,
  NgOptimizedImage,
  NgTemplateOutlet
} from '@angular/common';
import { RouterLink } from '@angular/router';
import { OverlaySwipeDirective } from '../../../shared/directives/modal-swipe/overlay-swipe.directive';
import { BottomSwipeSheetDirective } from '../../../shared/directives/modal-swipe/bottom-swipe-sheet.directive';
import { CounterComponent } from '../../../shared/components/counter/counter.component';
import { CurrencyComponent } from '../../../shared/components/price/currency.component';
import { DefaultPortionListComponent } from '../components/default-portion-list/default-portion-list.component';
import { DefaultSizePickerComponent } from '../components/default-size-picker/default-size-picker.component';
import { ModifierListModule } from '../../../components/modifier-list/modifier-list.module';
import { PictureFallbackDirective } from '../../../shared/directives/picture-fallback/picture-fallback.directive';
import { MatIconModule } from "@angular/material/icon";
import { ProductInfoPageAbstract } from '../../common/product-info-page.abstract';

@Component({
  selector: 'app-default-product-info-page',
  templateUrl: './default-product-info-page.component.html',
  styleUrls: ['./default-product-info-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    NgFor,
    AsyncPipe,
    RouterLink,
    NgTemplateOutlet,
    NgOptimizedImage,
    ReactiveFormsModule,
    LowerCasePipe,
    ModalSwipeDirective,
    OverlaySwipeDirective,
    BottomSwipeSheetDirective,
    ModifierListModule,
    CounterComponent,
    CurrencyComponent,
    DefaultPortionListComponent,
    DefaultSizePickerComponent,
    PictureFallbackDirective,
    MatIconModule,
  ]
})
export class DefaultProductInfoPageComponent extends ProductInfoPageAbstract { }
